import { Component, inject, Renderer2, DOCUMENT } from '@angular/core';
import { connectFunctionsEmulator, Functions } from '@angular/fire/functions';
import { environment } from '../environments/environment';
import { select, Store } from '@ngrx/store';
import { selectGetCompanySettingsTheme } from './company-settings/get-company-settings/store/get-company-settings.selectors';
import { NgbConfig, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { LoadingAppService } from './core/services/loading-app.service';
import { connectFirestoreEmulator, Firestore, } from '@angular/fire/firestore';
import { Auth, connectAuthEmulator } from '@angular/fire/auth';
import { connectStorageEmulator, Storage } from '@angular/fire/storage';
import { PageMetaService } from './core/services/page-meta.service';
import { ChunkErrorService } from './core/services/chunk-error.service';
import { ReloadAppModalComponent } from './shared/reload-app-modal/reload-app-modal.component';
import { APP_CONFIG } from './core/tokens/app-config.token';
import { RouterOutlet } from '@angular/router';


@Component({
  selector: 'app-root',
  imports: [ RouterOutlet ],
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.scss' ],
})
export class AppComponent {
  private readonly appConfig = inject(APP_CONFIG);
  private readonly functions = inject(Functions);
  private readonly firestore = inject(Firestore);
  private readonly storage = inject(Storage);
  private readonly auth = inject(Auth);
  private readonly renderer = inject(Renderer2);
  private readonly store$ = inject(Store);
  private readonly document = inject(DOCUMENT);
  private readonly ngbConfig = inject(NgbConfig);
  private readonly ngbModalConfig = inject(NgbModalConfig);
  private readonly loadingAppService = inject(LoadingAppService);
  private readonly pageMetaService = inject(PageMetaService);
  private readonly chunkErrorService = inject(ChunkErrorService);
  private readonly modalService = inject(NgbModal);

  constructor() {
    this.ngbConfig.animation = false;
    this.ngbModalConfig.backdrop = 'static';
    this.ngbModalConfig.keyboard = false;

    if (environment.useLocalFunctions && !environment.useEmulators) {
      connectFunctionsEmulator(this.functions, 'localhost', 5001);
    }

    if (environment.useEmulators) {
      connectFunctionsEmulator(this.functions, 'localhost', 5001);
      connectFirestoreEmulator(this.firestore, 'localhost', 8080);
      connectStorageEmulator(this.storage, 'localhost', 9199);
      connectAuthEmulator(this.auth, 'http://127.0.0.1:9099');
    }

    const bodyEl = this.document.querySelector('body');
    const titleEl = this.document.querySelector('title');

    this.store$.pipe(select(selectGetCompanySettingsTheme)).subscribe(companySettingsTheme => {
      const theme = companySettingsTheme || this.appConfig.defaultTheme;

      if (theme) {
        this.renderer.setAttribute(bodyEl, 'data-theme', `${ theme }-theme`);
      } else {
        this.renderer.removeAttribute(bodyEl, 'data-theme');
      }
    });

    this.loadingAppService.loading$.subscribe(loading => {
      const loadingAppEl = this.document.querySelector('#loading-app');
      if (!loadingAppEl) throw new Error('Unexpected: Missed loading app');
      this.renderer.setStyle(loadingAppEl, 'display', loading ? 'flex' : 'none');
    });

    this.pageMetaService.title$.subscribe(title => {
      this.renderer.removeChild(titleEl, titleEl?.childNodes[0]);
      this.renderer.appendChild(titleEl, this.renderer.createText(title));
    });

    this.chunkErrorService.errorEvent.subscribe(() => {
      this.modalService.open(ReloadAppModalComponent, {
        modalDialogClass: 'rmv-modal-small',
      });
    });
  }

}
